import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';
import { NavigationPluginInterface } from './definitions';
import { CAPACITOR_NAVIGATION_PLUGIN } from '../pluginConstants';

const NavigationPluginRaw = registerPlugin<NavigationPluginInterface>(CAPACITOR_NAVIGATION_PLUGIN);
const NavigationPlugin = withBridgedStackTrace(NavigationPluginRaw, CAPACITOR_NAVIGATION_PLUGIN);

export * from './definitions';
export { NavigationPlugin };
